export const THEME_STORAGE_KEY = 'qrsconfig@theme';

export const APP_THEMES = [
  { id: 'polgo-padrao', label: 'Polgo (Padrão)', preview: 'linear-gradient(135deg, #00a4ff, #7317cc)' },
  { id: 'oceano-abissal', label: 'Oceano Abissal', preview: 'linear-gradient(135deg, #00586b, #081b42)' },
  { id: 'coral', label: 'Coral', preview: 'linear-gradient(135deg, #d63384, #8f145a)' },
  { id: 'petroleo', label: 'Petróleo', preview: 'linear-gradient(135deg, #0f0f10, #1f2023)' },
];

const THEME_MIGRATIONS = {
  'oceano-profundo': 'oceano-abissal',
  'oceano-recife': 'petroleo',
  'oceano-noturno': 'petroleo',
  nemo: 'petroleo',
};

export function resolveThemeId(themeId) {
  const migrated = THEME_MIGRATIONS[themeId] || themeId;
  const exists = APP_THEMES.some((theme) => theme.id === migrated);
  return exists ? migrated : 'polgo-padrao';
}

export function getSavedThemeId() {
  if (typeof localStorage === 'undefined') {
    return 'polgo-padrao';
  }

  return resolveThemeId(localStorage.getItem(THEME_STORAGE_KEY));
}

export function applyAppTheme(themeId) {
  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.setAttribute('data-theme', resolveThemeId(themeId));
}

export function saveAppTheme(themeId) {
  const resolved = resolveThemeId(themeId);
  applyAppTheme(resolved);

  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(THEME_STORAGE_KEY, resolved);
  }

  return resolved;
}

export function initializeAppTheme() {
  return saveAppTheme(getSavedThemeId());
}
